var moment = require('moment');
var module = angular.module('octopusApp.projects');

module.directive('deploymentCreateSchedule', function() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            scheduledAt: '=',
            expiresAt: '='
        },
        templateUrl: 'areas/projects/deployment-create/deployment-create-schedule.html',
        controller: function($scope) {
            var vm = this;
            vm.isScheduled =false;
            vm.scheduledDate = new Date();
            vm.scheduledTime= new Date();
            vm.expiryDate = new Date();
            vm.expiryTime = new Date();
            vm.minDate = new Date();
            vm.maxDate = moment().add(14, 'days');
            vm.userTimezone = moment().format("[GMT] Z");
            vm.updateScheduled = updateScheduled;
            vm.updateExpiry = updateExpiry;
            vm.moment = moment;

            function init() {
                $scope.$watch(function() { return vm.scheduledDate; }, function(){ updateScheduled(); });
                $scope.$watch(function() { return vm.expiryDate; }, function(){ updateExpiry(); });

                vm.scheduledTime = rollForward(moment(), 10);
                vm.expiryTime = rollForward(moment(vm.scheduledTime), 30);
            }

            function rollForward(date, minutes)
            {
                var mins = 0;
                var now = date.add(minutes, 'minutes');
                var hour = now.hour();
                if (now.minute() > 45) {
                    mins = 0;
                    hour++;
                } else if (now.minute() > 30) {
                    mins = 45;
                } else if (now.minute() > 15) {
                    mins = 30;
                } else if (now.minute() > 0) {
                    mins = 15;
                }
                return new Date(2000, 1, 1, hour, mins);
            }

            function updateScheduled() {
                updateScheduleDates();
                ensureExpiryDateIsInTheFuture();
            }

            function updateScheduleDates()
            {
                if(!vm.isScheduled || !vm.scheduledDate) {
                    vm.scheduledAt = null;
                    vm.expiresAt = null;
                    return;
                }

                vm.scheduledAt = combineDateTime(vm.scheduledDate, vm.scheduledTime);
                vm.expiresAt = combineDateTime(vm.expiryDate, vm.expiryTime);
            }

            function ensureExpiryDateIsInTheFuture()
            {
                if (!vm.expiresAt || !vm.scheduledAt)
                {
                    return;
                }

                if (vm.expiresAt > vm.scheduledAt)
                {
                    return;
                }

                vm.expiryDate = vm.scheduledDate;
                vm.expiryTime = rollForward(moment(vm.scheduledTime), 30);
                vm.expiresAt = combineDateTime(vm.expiryDate, vm.expiryTime);
            }

            function updateExpiry() {
                updateScheduleDates();
            }

            function combineDateTime(date, time)
            {
                var combine = moment(date).utcOffset(moment().utcOffset());
                if (time) {
                    var t = moment(time);
                    combine.hour(t.hour());
                    combine.minute(t.minute());
                }
                return combine;
            }

            init();
        },
        bindToController: true,
        controllerAs: 'vm'
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/deployment-create/deployment-create-schedule.js
// module id = 3013802591874107
// module chunks = 1